import React from 'react';

import type { InputApi } from './hooks';
import type { InputProps } from './InputProps';
import DefaultInput, { InputContainer } from './variants/Default';
import TCKNInput, { TCKNProps } from './variants/TCKN';

export * from './hooks';

const VariantsMap = {
  default: DefaultInput,
  tckn: TCKNInput,
};

type Variant = keyof typeof VariantsMap;
type WithVariant<V extends Variant, T = unknown> = {
  variant?: V;
} & T;

type DefaultVariant = WithVariant<'default'>;
type TCKNVariant = WithVariant<'tckn', { alwayseditable?: boolean }>;
type InputVariants = DefaultVariant | TCKNVariant;
type CommonProps = InputVariants & {
  onChange?: (value: string) => void;
  inputRef?: React.MutableRefObject<HTMLInputElement | null>;
  getInputAPI?: (
    api: InputApi,
    nativeInputRef?: React.MutableRefObject<HTMLInputElement>
  ) => void;
  alwayseditable?: boolean;
  isTcknRequired?: boolean;
  checkboxMode?: 'controlled' | 'uncontrolled';
  inputDisable?: boolean;
  tcknType?: string;
  iconLeft?: boolean;
};
export type SeturInputProps = InputProps & TCKNProps & CommonProps;

const hasCheckbox = (variant: SeturInputProps['variant']) =>
  variant !== 'default';

const Input = (props: React.PropsWithChildren<SeturInputProps>) => {
  const Input = VariantsMap[props.variant ?? 'default'];
  const { alwayseditable = false, ...rest } = hasCheckbox(props.variant)
    ? (props as TCKNVariant)
    : { ...props, alwayseditable: undefined };
  return <Input {...rest} alwayseditable={alwayseditable} />;
};

export default Input;

export { InputContainer };
